import type { ReactNode } from 'react';
import clsx from 'clsx';
import { Button } from '@oysterjs/ui/button';

/**
 * Short feature intro with optional doc link — matches the Integrations / Voice settings pattern
 * (title, one-to-two sentences, documentation button).
 */
export function FeatureDocCallout(props: {
  title: ReactNode;
  description: ReactNode;
  docHref?: string;
  docLabel?: string;
  /** Replaces the default documentation button when set. */
  action?: ReactNode;
  variant?: 'neutral' | 'sky';
  className?: string;
}) {
  const {
    title,
    description,
    docHref,
    docLabel = 'View documentation',
    action,
    variant = 'neutral',
    className
  } = props;
  const resolvedAction =
    action ??
    (docHref ? (
      <Button
        color="white"
        href={docHref}
        target="_blank"
        rel="noreferrer"
        className="shrink-0 self-start"
      >
        {docLabel}
      </Button>
    ) : null);

  return (
    <div
      className={clsx(
        'rounded-lg border px-4 py-3',
        variant === 'sky'
          ? 'border-sky-200 bg-sky-50 dark:border-sky-500/30 dark:bg-sky-500/10'
          : 'border-neutral-200 bg-neutral-50 dark:border-neutral-700 dark:bg-neutral-900/40',
        className
      )}
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
        <div className="min-w-0">
          <div className="text-sm font-semibold text-neutral-900 dark:text-white">{title}</div>
          <p className="mt-1 text-sm text-neutral-600 dark:text-neutral-400">{description}</p>
        </div>
        {resolvedAction}
      </div>
    </div>
  );
}
